
import { defineComponent, PropType } from 'vue';
import { SelectItem } from './all.type';

export default defineComponent({
    props: {
        list: {
            type: Array as PropType< Array<SelectItem> >,
            required: true
        },
        active: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit }) {
        const choose = (value: SelectItem) => {
            emit('change', value.key);
        };

        return {
            choose
        };
    }
});
